<template>
    <div class="" v-if="content">
        <div class="w-full">
            <Select
                label="Image Position"
                name="image_position"
                v-model="content.image_position"
                class="ml-3"
                :options="[
                    { value: null, name: '' },
                    { value: 'left', name: 'Left' },
                    { value: 'top', name: 'Top' },
                ]"
            />
        </div>

        <media-reference
            :gallery="gallery"
            :language="language"
            v-model="content.image"
            class="my-3"
            label="Image"
            name="image"
        />

        <rocket-link
            class="my-3"
            :language="language"
            v-model="content.link"
            label="Image Link"
            :hide-link-text="true"
            :resettable="true"
        />

        <content-editor
            :value="content.table_markup"
            :content-data="content.table_markup"
            @input="onInput"
            :toolbarButtons="[
                'rocketLink',
                'insertTable',
                'italic',
                'formatOL',
                'formatUL',
                'bold',
                'underline',
                'strikeThrough',
                'subscript',
                'superscript',
                'undo',
                'redo',
                'clearFormatting',
                'html'
            ]"
            :language="language"
        ></content-editor>

        <input type="hidden" :value="content.table_markup" :name="name"/>

        <input-text
            label="Number of visible rows"
            name="number_of_visible_rows"
            v-model="content.number_of_visible_rows"
            class="mt-5"
        />
    </div>
</template>
<script>
import siteLanguage from '../../config/siteLanguage'
import MediaReference from "../media/MediaReference";
import RocketLink from "../Link/RocketLink.vue";

export default {
    name: "TableBuilder",
    components: {RocketLink, MediaReference },
    props: {
        gallery: Array,
        value: {
            type: Object,
            default: () => {
                return {
                    table_markup: "",
                    image: null,
                    image_id: null,
                    image_position: null,
                    link: {},
                    number_of_visible_rows: null
                }
            }
        },
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
        id: String,
        name: String,
    },
    data() {
        return {
            content: this.value
        };
    },
    mounted() {
        this.content = this.value || {
                    table_markup: "",
                    image: null,
                    image_id: null,
                    image_position: null,
                    link: {},
                    number_of_visible_rows: null
                };
    },
    methods: {
        onInput(value) {
            this.content.table_markup = value;
            this.$emit("input", this.content);
        },
    },
    watch: {
        value: function (val) {
            this.content = val;
        },
        "content.image_position": function(newValue){
            if (!this.content.table_markup) {
                this.content.table_markup = null;
            }
            this.$emit("input", this.content);
        },
        "content.number_of_visible_rows": function(newValue){
            if (!this.content.table_markup) {
                this.content.content_table = null;
            }
            this.$emit("input", this.content);
        },
        "content.image": function (newValue) {
            this.content.image_id = newValue?.id || null;
        },
        "link": {
            deep: true,
            handler: function (newValue) {
                this.$emit("input", this.content);
            },
        }
    }
};
</script>
